<template>
    <div>
        <transition name="fade">

            <div id="modal-order" class="modal" :class="{'is-active': lead}">
                <div class="modal-background" @click="$emit('close')"></div>
                <div class="modal-content" style="padding: 2rem 2rem;">
                    <!-- Any other Bulma elements you want -->
                    <i class="fa fa-fw fa-3x fa-check-circle has-text-success mb20" style="font-size:4rem;"></i>

	                <div v-if="!clientExists">
		                <p style="font-size: 1.7rem; font-weight: 300;" class="mb20">Já só falta confirmar e já está!</p>

		                <p style="margin:0 2.5rem; text-align: justify; font-size:0.8rem;" class="mb20">A confirmação dos seus dados é importante. O Facilimo nunca irá usar qualquer dados para além desta finalidade. Nem em momento algum lhe será cobrado qualquer valor por qualquer tipo de notificação enviada (e-mail ou SMS).</p>

		                <p v-if="lead && lead.email && lead.phone" style="margin:0 2.5rem; text-align: justify; background-color: #FACEE0; padding: 1.5rem; font-size:0.8rem;">Para confirmar o seu pedido, por favor clique no link enviado
			                para o e-mail <b>{{lead.email}}</b> e por SMS para o &numero; <b>{{lead.phone}}</b>.</p>

		                <p>&nbsp;</p>

		                <div style="text-align: center" class="pb20 mt20">
			                <p><a class="button2 is-primary mb12" style="font-weight: 500" @click="viewLead()">VER PROJETO</a></p>
		                </div>
	                </div>
	                <div v-else="">
		                <p style="font-size: 1.7rem; font-weight: 300;" class="mb20">O seu pedido foi submetido com sucesso!</p>

		                <p style="margin:0 2.5rem; text-align: justify; font-size:0.8rem;" class="mb20">Agora que o seu pedido foi submetido com sucesso, o trabalho é connosco. Iremos colocar o seu pedido aos Profissionais registados no FACILIMO para que eles lhe possam apresentar a sua melhor proposta.
			                Lembre-se que poderá contactar o Profissional a qualquer momento, seja por telefone ou chat. </p>

		                <p>&nbsp;</p>


		                <p style="margin:0 2.5rem; text-align: justify; font-size:0.8rem;" class="mb20">Se uma proposta lhe interessar, clique no botão "Contratar" e já está! </p>

		                <p>&nbsp;</p>

		                <div style="text-align: center" class="pb20">
			                <p><a class="button2 is-primary mb12" style="font-weight: 500; min-width: 12rem; min-height: 3.25rem; max-height: 3.25rem;" @click="viewLead()">LOGIN</a></p>
		                </div>
		                <p style="font-weight: 400; color: black; font-size: 0.6rem">Se não tem, ou não sabe, a sua password de acesso à sua Área Privada, recupere-a <span style="text-decoration: underline; cursor: pointer" @click="$router.push({name: 'forgot'})">aqui</span>.</p>
	                </div>


                </div>
            </div>
        </transition>

    </div>

</template>

<script>
	import {apiUrl} from "../vars";
	import {appUrl} from "../vars";

	export default {
  props: ["messageModal", "lead", "clientExists"],
	methods: {
  	    viewLead(){

  	    	if (this.clientExists || this.clientExists !== false) {
  	    		this.$router.push({name:'signin'});
	        } else {
		        window.location.href = `l?s=${this.lead.s}&l=${this.lead.cod}`
	        }


        },


		cancelLead(){

	        axios.get(`${apiUrl}/leads/archive?id=${this.lead.id}`).then(r=>{
			    this.$emit('close');

		    })


		},


	}
};
</script>
<style scoped>
.modallogo {
  height: 3rem;
}

.modallogorpc {
  min-height: 3rem;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  background-color: #fff;
  padding: 1rem 0;
  text-align: center;
  border-radius: 5px;
  min-height: 72vh;
  max-height: 72vh;

	overflow-y: hidden;
}

.f-modal-text {
  padding: 2rem 4rem;

  text-align: left;
  color: white;
  font-size: 1.75rem;
  //margin: 2rem 0;
}

.f-modal-close {
  color: #eac5d9;
  position: absolute;
  font-size: 2rem;
  top: 1.5rem;
  right: 1.5rem;
  cursor: pointer;
}

.button {
  border-radius: 5px;
  font-size: 1.5rem;
  font-weight: 400;
  padding: 1em 2rem;
  height: 4rem;
}

.bmod {
  background-color: #eac5d9;
  color: #e90054;
}

@media only screen and (min-width: 769px) {
}

@media only screen and (max-width: 768px) {
  .modal-content {
    padding: 4rem 2rem;
  }
  .f-modal-text {
    color: white;
    font-size: 1.5rem;
    margin: 1rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LeadConfirmation.vue